import React from "react";

/**
 * Holds the currently-selected base currency (e.g. “EUR”).
 * Defaults to “EUR” so nothing crashes before the user picks one.
 */
export const CurrencyContext = React.createContext("EUR");
